import { reportAxios } from "ultis/axios";

/**api lấy log cuộc gọi outbound*/
const getLogOutboundCalls = (params) => {
  return reportAxios.get("/api/v1/reports/outbound-call/log", {
    params,
  });
};

export const OutboundApi = { getLogOutboundCalls };
